import React from 'react';
import PropTypes from 'prop-types';
import 'components/styles/custom-input.css';
import { ReactComponent as HintIcon } from 'assets/images/hint-icon.svg';

const CustomInput = ({
  type = 'text',
  label,
  fullLength,
  value,
  error,
  onChange,
  onBlur,
  success,
}) => {
  return (
    <div
      className={`input-container ${error ? 'error' : ''} ${fullLength ? 'fullLength' : ''} ${
        success ? 'success' : ''
      }`}>
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onBlur={() => {
          if (onBlur) {
            onBlur(value);
          }
        }}
      />
      <label className={value && 'filled'} htmlFor={label}>
        {label}
      </label>
      {error && (
        <div className="error-message">
          <HintIcon/>
          {error}
        </div>
      )}
    </div>
  );
};

CustomInput.propTypes = {
  type: PropTypes.string,
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  error: PropTypes.string,
  success: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func,
  fullLength: PropTypes.bool,
};

export default CustomInput;
